export default __webpack_public_path__ + "static/stock-8870bda2676bce6c431aa6aac4110041.png";